<template>
  <div>
    <b-badge
      v-if="!button"
      :variant="variant"
      :title="title"
      v-b-tooltip.hover
    >
      <i :class="`fa fa-fw fa-${icon}`"></i>
    </b-badge>
    <b-button
      v-if="button"
      :variant="variant"
      :size="buttonSize"
      :class="buttonClass"
      @click="$emit('click', $event)"
      :title="title"
      v-b-tooltip.hover
    >
      <i :class="`fa fa-fw fa-${icon}`"></i>
    </b-button>
  </div>
</template>

<script>
  export default {
    props: {
      location: Object,
      button: {
        type: Boolean,
        default: false,
      },
      buttonSize: {
        type: String,
        default: null,
      },
      buttonVariantOutline: {
        type: Boolean,
        default: false,
      },
      buttonClass: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
      }
    },
    computed: {
      variant() {
        let variant = !!this.location.disabled_at ? 'danger' : 'success'
        if (this.buttonVariantOutline) variant = 'outline-' + variant
        return variant
      },
      icon() {
        return !!this.location.disabled_at ? 'exclamation-triangle' : 'check'
      },
      title() {
        if (!this.location.disabled_at) return trans('available')
        return this.location.disabled_note
      },
    },
  }
</script>